import { Button } from '@airbus/components-react';
import { useConfigContext } from '../../context/ConfigContext';
import styles from './LoginButton.module.css';

export default function LoginButton({ children }) {
  const config = useConfigContext();

  if (!config.cognitoDomain) {
    return null;
  }

  const callbackUri = encodeURI(config.redirectUri);

  const loginUrl = `${config.cognitoDomain}/oauth2/authorize?client_id=${config.clientId}&redirect_uri=${callbackUri}&response_type=code&scope=openid`;

  const onLogin = () => {
    window.location.replace(loginUrl);
  };

  return (
    <div className={styles.buttonWrapper}>
      <Button variant='primary' onClick={onLogin}>
        {children}
      </Button>
    </div>
  );
}
